import { loadStripe } from '@stripe/stripe-js';
import './App.css';
import MainRouter from './Router/MainRouter';



function App(props) {
  // console.log("App props", props);
  const initialPath = props?.initialPath || "/";

  // console.log("App Initial Path:", initialPath); 
  return (
    <div className="App">
      {/* <Elements stripe={stripePromise}> */}
      <MainRouter initialPath={initialPath} productCategoryId={props?.productCategoryId} resheduleKey={props?.resheduleKey} stateCode={props?.stateCode} authCode={props?.authCode} productId={props?.productId} clinicId={props?.clinicId} hashCode={props?.hashCode} partnerId={props?.partnerId} hideAdditionalPreferences={props?.hideAdditionalPreferences}/>
      {/* </Elements> */}

      <style jsx>
  {`
    /* Prevent Safari zoom on focus */
    input[type="text"],
    input[type="email"],
    input[type="tel"],
    input[type="password"],
    input[type="search"],
    input[type="number"],
    select,
    textarea {
      font-size: 16px !important;
    }

    /* Ant Design specific overrides */
    .ant-input,
    .ant-select-selector,
    .ant-select-selection-search-input,
    .ant-radio-wrapper {
      font-size: 16px !important;
    }

    /* Your existing styles */
    .html-content p,
    .html-content h1,
    .html-content h2,
    .html-content ul,
    .html-content b,
    .html-content strong,
    .html-content li {
      font-weight: 400 !important;
      margin: 0 !important;
      padding: 0;
    }

    .html-content em {
      font-style: normal;
      color: inherit;
    }
  `}
</style>
    </div>
  );
}

export default App;
